import React, { useEffect } from "react";
import { Scanner } from "@softdevintegrations/market-scanner-ui";
import "./RadarContainer.scss";
import { Helmet } from "react-helmet";

const SCANNER_URL = process.env.REACT_APP_SCANNER_URL;

const cookieAuth = { getToken: () => "" };

function RadarScannerContainer() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ height: "85vh" }} className="radar container">
      <Helmet>
        <title> Scanner | TradeAlgo </title>
      </Helmet>
      <Scanner
        scannerUrl={SCANNER_URL}
        auth={cookieAuth}
        allowTableExport={true}
        height="100%"
      />
    </div>
  );
}

export default RadarScannerContainer;
